/**
 * @generated SignedSource<<f22bb1e2454483f08c45527f2917f681>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type SettingsAction_query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"TopNavSettingsMenu_project_query">;
  readonly " $fragmentType": "SettingsAction_query";
};
export type SettingsAction_query$key = {
  readonly " $data"?: SettingsAction_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"SettingsAction_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "SettingsAction_query",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "TopNavSettingsMenu_project_query"
    }
  ],
  "type": "Query"
};

(node as any).hash = "968d87a4d8579fe1f70986799a86ffd8";

export default node;
